import React from "react";
import { Create, SimpleForm, TextInput, required } from "react-admin";
import FormContainer from "../common/FormContainer";
import useCreateWithValidation from "../common/useCreateWithValidation";

const CustomerCreate = () => {
  const save = useCreateWithValidation("Customer", { redirectTo: "show" });

  return (
    <Create>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <TextInput source="name" validate={required()} fullWidth />
          <TextInput source="contactPerson" fullWidth />
          <TextInput source="crmId" />
        </FormContainer>
      </SimpleForm>
    </Create>
  );
};

export default CustomerCreate;
